export const LoadingSkeleton = () => (
  <div className="card-board overflow-hidden">
    <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
      <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
        Averages
      </h1>
      <p className="text-sm text-brand-mist mt-1">
        Bowler averages for this tournament.
      </p>
    </div>
    <div className="overflow-x-auto animate-pulse">
      <table className="min-w-full">
        <thead>
          <tr className="bg-brand-charcoal">
            <th className="px-6 py-3">
              <div className="h-4 bg-brand-mist/40 rounded w-3/4"></div>
            </th>
            <th className="px-6 py-3">
              <div className="h-4 bg-brand-mist/40 rounded w-3/4"></div>
            </th>
            <th className="px-6 py-3">
              <div className="h-4 bg-brand-mist/40 rounded w-3/4"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3].map((i) => (
            <tr key={i} className="border-b border-brand-charcoal/10">
              <td className="px-6 py-4">
                <div className="h-4 bg-brand-mist/30 rounded w-3/4"></div>
              </td>
              <td className="px-6 py-4">
                <div className="h-4 bg-brand-mist/30 rounded w-1/4"></div>
              </td>
              <td className="px-6 py-4">
                <div className="h-4 bg-brand-mist/30 rounded w-1/4"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
